import React, {useState} from 'react';
import {FilterDealerTranslation} from '../../typing/translations';
import {DealerFilterItem, FilterItem} from '../../typing/used-inventory';
import {FilterCheckBox} from '../filter-checkbox';
import FilterContentLabel from '../filter-content-label';
import {getDealerLabel} from './helpers';
import {StyledDealersContainer, StyledFilterDealerContainer} from './styles';

interface FilterDealerProps {
  dealers: DealerFilterItem[];
  onHandleDealerCheck: (item: FilterItem) => void;
  translation: FilterDealerTranslation;
  isMobile: boolean;
}
const FilterDealer: React.FC<FilterDealerProps> = ({
  dealers,
  translation,
  onHandleDealerCheck,
  isMobile
}) => {
  const [hideOptions, setHideOptions] = useState(false);

  return (
    <StyledFilterDealerContainer className="filter-dealer-container">
      <div className="label-wrapper">
        <FilterContentLabel
          label={translation.label}
          hideOptions={hideOptions}
          setHideOptions={setHideOptions}
          isMobile={isMobile}
        />
      </div>
      {(hideOptions && isMobile) || !isMobile ? (
        <StyledDealersContainer className="checkbox-container">
          {dealers.map((dealer: DealerFilterItem) => (
            <FilterCheckBox
              key={dealer.key}
              label={getDealerLabel(
                {
                  name: dealer.value,
                  distance: dealer.distance,
                },
                translation.milesLabel,
              )}
              value={dealer.key}
              onClick={onHandleDealerCheck.bind(null, dealer)}
              checked={dealer.isChecked}
            />
          ))}
        </StyledDealersContainer>
      ): null}
    </StyledFilterDealerContainer>
  );
};

export default FilterDealer;
